import React from 'react';
import { StyleSheet, View } from 'react-native';
import theme from '../../common/theme';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    opacity: 0.8,
    backgroundColor: theme.colors.black,
  },
});

const Backdrop: React.FC = () => {
  return <View style={styles.container}></View>;
};

export default Backdrop;
